import { render, staticRenderFns } from "./medicalOrder.vue?vue&type=template&id=618e9a42&scoped=true&"
import script from "./medicalOrder.vue?vue&type=script&lang=js&"
export * from "./medicalOrder.vue?vue&type=script&lang=js&"
import style0 from "./medicalOrder.vue?vue&type=style&index=0&id=618e9a42&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e9a42",
  null
  
)

component.options.__file = "medicalOrder.vue"
export default component.exports